import { motion } from "framer-motion";
import styles from "./css/Question.module.css";
import { pageVariants, pageTransition, btnHover, btnTap } from "../utils/animations";

const Question00 = ({ setAvance }) => {
	return (
		<motion.div
			className={styles.containerQuestion}
			variants={pageVariants}
			initial="initial"
			animate="animate"
			exit="exit"
			transition={pageTransition}
		>
			<div className={styles.titleQuestion}>
				Agradecemos su disponibilidad para participar en la siguiente encuesta.
			</div>
			<div className={styles.containerOptions}>
				<motion.button
					className={styles.controlButton}
					onClick={() => setAvance(1)}
					whileHover={btnHover}
					whileTap={btnTap}
				>
					Iniciar
				</motion.button>
			</div>
		</motion.div>
	);
};

export default Question00;
